enum Events {
  Page = 'Page',
}

export default Events
